export enum AnalyticCampaignType {
  TOMRA = 'tomra',
  TOKEN = 'redemptionToken',
  CASHBACK_BRANDS = 'cashbackToken',
}
